// extracted by mini-css-extract-plugin
module.exports = {"root":"MenuLabel_root__2fKJ_","clickedWithMouse":"MenuLabel_clickedWithMouse__lLyEU","isOpen":"MenuLabel_isOpen__djcL_"};